import {GridLayout} from 'layouts/gridLayout'
import {PageHeader} from 'layouts/pageHeader'
import {FACEBOOK_ICONS} from 'Pages/facebookManament/interfaces/_icons'
import {useState} from 'react'
import {FacebookLayoutGeneralLogoutModal} from './logoutModal'
import {FacebookLayoutGeneralSidebar} from './sidebar'
import {FacebookLayoutGeneral__ActionBtn} from './__actionBtn'
import {FacebookFanpageLayoutGeneral__Avatar} from './__avatar'
import ConfirmChanged from './confirmChanged'
import useGlobalContext from '../../../../containerContext/storeContext'
import {Text} from '../../../../common/text'
import { useTranslation } from 'react-i18next'
import {checkPermission} from "../../../../Component/NavBar/until";
import PopupNotPermission from "../../../permision/popupNotPermission";
import * as React from "react";
import {useNavigate} from "react-router-dom";

export const FacebookLayoutGeneral = ({
  title,
  subTitle,
  description,
  breadcrumb,
  authData,
  actions,
  logout,
  description_2,
  tooltipSubTitle='',
  isUl=false,
  ...props
}) => {
  const { t } = useTranslation()
  const [shouldOpenLogoutModal, setShouldOpenLogoutModal] = useState(false)

  const [GlobalState, GlobalDispatch] = useGlobalContext()
  const leavePage = path => {
    GlobalDispatch({
      type: 'UPDATE_CHANGE_STATUS',
      payload: {
        showPopup: true,
        link: path,
      },
    })
  }
  const navigate = useNavigate()
  const validFanpagePermission = checkPermission('facebook', 'fanpage')
  const validConversationPermission = checkPermission('facebook', 'conversation')
  const validLivestreamPermission = checkPermission('facebook', 'livestream')
  const validOrdersPermission = checkPermission('facebook', 'orders')

  const handleLinkFanpage = _ => validFanpagePermission ? navigate('/facebook') : setShowPermission(true)

  const handleLinkSetting = _ => validConversationPermission ? navigate('/facebook/conversation') : setShowPermission(true)

  const handleLinkLivestream = _ => validLivestreamPermission ? navigate(`/facebook/livestream`) : setShowPermission(true)

  const handleLinkOrder = _ => validOrdersPermission ? navigate(`/facebook/orders`) : setShowPermission(true)

  const [showPermission, setShowPermission] = useState(false)
  return (
    <>
      {showPermission && <PopupNotPermission handleClose={() => setShowPermission(false)}/>}
      <GridLayout
        {...props}
        header={
          <PageHeader
            breadcrumbLinks={breadcrumb}
            confirmBack={
              GlobalState?.facebookAuth?.changed?.status
                ? () => leavePage(breadcrumb[0]?.url)
                : ''
            }
            breadcrumbTitle={title}
            actions={[
              {
                id: 1,
                children: (
                  <FacebookLayoutGeneral__ActionBtn
                    tooltip={t('facebookManament_conversation')}
                    icon={FACEBOOK_ICONS.chatCircleDots}
                    // href={'/facebook/conversation'}
                    onClick={handleLinkSetting}
                  />
                ),
              },
              {
                id: 2,
                children: (
                  <FacebookLayoutGeneral__ActionBtn
                    tooltip={t('facebookManament_livestream_list')}
                    icon={FACEBOOK_ICONS.livestream01}
                    // href={'/facebook/livestream'}
                    onClick={handleLinkLivestream}
                  />
                ),
              },
              {
                id: 3,
                children: (
                  <FacebookLayoutGeneral__ActionBtn
                    tooltip={t('facebookManament_order')}
                    icon={FACEBOOK_ICONS.handBag01}
                    // href={'/facebook/orders'}
                    onClick={handleLinkOrder}
                  />
                ),
              },
              {
                id: 4,
                children: (
                  <FacebookLayoutGeneral__ActionBtn
                    tooltip={t('facebookManament_fanpage_connection')}
                    icon={FACEBOOK_ICONS.facebookAnchor}
                    // href={'/facebook'}
                    onClick={handleLinkFanpage}
                  />
                ),
              },
              {
                id: 5,
                children: (
                  <Text
                    style={{
                      borderLeft: '1px solid #C8CBD4',
                      height: '44px',
                      display: 'inline-block',
                      paddingRight: '12px',
                    }}
                  />
                ),
              },
              {
                id: 6,
                children: (
                  <FacebookFanpageLayoutGeneral__Avatar
                    avatar={authData?.user?.avatar}
                    name={authData?.user?.name}
                    onToggleLogoutModal={setShouldOpenLogoutModal}
                  />
                ),
              },
            ]}
          />
        }
        grid={[
          {
            width: 15.5,
            sections: [
              {
                props: {
                  style: {
                    padding: 0,
                    background: 'transparent',
                  },
                  children: <FacebookLayoutGeneralSidebar />,
                },
              },
            ],
            props: {style: {position: 'sticky', top: 0, width: 277}},
          },
          {
            width: 84.5,
            sections: [
              {
                title: subTitle,
                description,
                description_2,
                tooltipSubTitle,
                isUl,
                actionProps: {style: {top: 0}},
                actions,
                props: {
                  descriptionProps: {style: {marginTop: 4, width: '80%'}},
                  children: props?.children,
                  style: {
                    marginBottom: 0,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                  },
                },
              },
            ],
            props: {style: {width: 'calc(100% - 277px)'}},
          },
        ]}
      />
      {shouldOpenLogoutModal && (
        <FacebookLayoutGeneralLogoutModal
          onClose={() => setShouldOpenLogoutModal(false)}
          onSubmit={logout}
        />
      )}
      <ConfirmChanged />
    </>
  )
}
